module.exports = __webpack_public_path__ + "static/media/quivers2.868849c4.png";